const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          suppliers: 'Flotas',
        },
      },
    },
  },
};

export default layout;